"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _glamor = require("glamor");

var _Form = require("@quixeltools/quixel-ui-library/dist/components/common/website/Form");

var _Form2 = _interopRequireDefault(_Form);

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _TextArea = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextArea");

var _TextArea2 = _interopRequireDefault(_TextArea);

var _Select = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Select");

var _Select2 = _interopRequireDefault(_Select);

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _IndieProgramPopup = require("@quixeltools/quixel-ui-library/dist/components/common/gallery/IndieProgramPopup");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _Radio = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Radio");

var _Radio2 = _interopRequireDefault(_Radio);

var _EducationSubscriptionEULA = require("./EducationSubscriptionEULA");

var _EducationSubscriptionEULA2 = _interopRequireDefault(_EducationSubscriptionEULA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var textInput = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(1)
});

var nameEmails = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(1),
  width: "17.5rem"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  marginRight: "1.5rem",
  width: "100%"
}));

var nameEmail = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-between",
  margin: "auto"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  flexDirection: "column"
}));

var infoContainer = (0, _glamor.css)({
  display: "flex",
  flexDirection: "column",
  marginTop: (0, _css.unitRem)(1.2),
  marginBottom: (0, _css.unitRem)(1.5)
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginTop: (0, _css.unitRem)(1),
  marginBottom: (0, _css.unitRem)(1)
}));

var foot = (0, _glamor.css)(_css.clearfix, {
  display: "block",

  marginTop: (0, _css.unitRem)(2),
  textAlign: "center"
}, (0, _css.minWidth)(_css.breakpoints.medium)({}));

var submitButton = (0, _glamor.css)({
  position: "relative",
  margin: "0 auto"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  float: "right",
  display: "block"
}));
var selectField = (0, _glamor.css)({
  width: "100%",
  borderRadius: "0",
  webkitAppearance: "none",
  "& ul": {
    top: "3rem"
  }
});

var sizes = (0, _glamor.css)({
  marginBottom: "0.5rem",
  marginTop: "0.8rem",
  textTransform: "uppercase",
  color: "#6F6F6F",
  fontSize: "0.9375rem",
  fontWeight: "700",
  textAlign: "left",
  display: "block"
}, (0, _css.maxWidth)(_css.breakpoints.mediumSmall)({
  marginLeft: "0rem",
  paddingBottom: "1rem"
}));
var duration = [{ name: "1 year", value: "12" }];
var programType = [{ name: "Education Free", value: "Education Free" }];

var label = (0, _glamor.css)({
  display: "block",
  color: _css.colors.gray,
  textTransform: "uppercase",
  fontWeight: 700,
  marginBottom: (0, _css.unitRem)(0.25),
  fontSize: (0, _css.unitRem)(0.75)
}, (0, _css.maxWidth)(_css.breakpoints.super4k)({
  fontSize: (0, _css.unitRem)(0.725)
}), (0, _css.maxWidth)(_css.breakpoints.xxxlarge)({
  fontSize: (0, _css.unitRem)(0.7)
}), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  fontSize: (0, _css.unitRem)(0.675)
}), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  fontSize: (0, _css.unitRem)(0.65)
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  fontSize: (0, _css.unitRem)(0.625)
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  fontSize: (0, _css.unitRem)(0.6),
  marginTop: "1.5rem"
}));

var info = (0, _glamor.css)({
  display: "flex",
  marginTop: "1.5rem",
  marginBottom: "1.2rem",
  justifyContent: "start",
  paddingRight: 4
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  flexDirection: "column"
}));
var radio = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "middle"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  marginLeft: 0
}));
var flexChild = (0, _glamor.css)({
  flexBasis: "25%"
});

var note = (0, _glamor.css)({
  fontWeight: "500",
  verticalAlign: "middle",
  color: "#6F6F6F"
});
var title = (0, _glamor.css)(_fonts.H5, {
  fontSize: "1.875rem!important",
  letterSpacing: "-1.5px!important",
  marginTop: 0,
  marginBottom: (0, _css.unitRem)(1.25)
  // textAlign: 'center',
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  // textAlign: 'left',
  marginBottom: (0, _css.unitRem)(0.5)
}));

var description = (0, _glamor.css)(_fonts.p3, {
  color: _css.colors.gray
});
var dropDownLabel = (0, _glamor.css)(_fonts.popupFieldLabel, {
  marginBottom: "0.5rem",
  marginTop: "0.8rem",
  textTransform: "uppercase",
  color: "#6F6F6F",
  textAlign: "left",
  display: "block"
}, (0, _css.maxWidth)(_css.breakpoints.mediumSmall)({
  marginLeft: "0rem",
  paddingBottom: "1rem"
}));

var checkboxContainer = (0, _glamor.css)({
  display: "flex",
  alignItems: "end",
  marginTop: "24px"
});

var anchor = (0, _glamor.css)({
  textDecoration: "none",
  marginLeft: "3px",
  color: "#2b98f0",
  transition: "box-shadow 0.2s, color 0.2s ease-in-out"
});

function renderEducationSubscriptionForm(props) {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "div",
      { className: nameEmail },
      _react2.default.createElement(
        "div",
        { className: nameEmails },
        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
          label: "Name",
          placeholder: "Your full name",
          type: "text",
          disabled: props.submitting,
          autoComplete: true
        }, props.nameInputProps))
      ),
      _react2.default.createElement(
        "div",
        { className: nameEmails },
        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
          label: "Email",
          placeholder: "Your Email Address",
          type: "email",
          disabled: true,
          autoComplete: true
        }, props.emailInputProps))
      )
    ),
    _react2.default.createElement(
      "div",
      { className: infoContainer },
      _react2.default.createElement(
        "div",
        { className: label },
        "Work Info"
      ),
      _react2.default.createElement(
        "div",
        { className: info },
        _react2.default.createElement(
          "div",
          {
            className: (0, _glamor.css)(flexChild, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({ marginBottom: "1rem" }))
          },
          _react2.default.createElement(_Radio2.default, (0, _extends3.default)({
            className: radio
          }, props.workInfoProps, {
            value: "Teacher",
            label: "I'm a teacher",
            name: "radio",
            required: true
          }))
        ),
        _react2.default.createElement(
          "div",
          { className: flexChild },
          _react2.default.createElement(_Radio2.default, (0, _extends3.default)({
            className: radio
          }, props.workInfoProps, {
            value: "School Admin",
            label: "I'm a school admin",
            name: "radio",
            required: true
          }))
        )
      ),
      _react2.default.createElement(
        "div",
        { className: info },
        _react2.default.createElement(
          "p",
          { className: note },
          "Note: This program is only available to teachers and schools. If you\u2019re a student please ask your school to apply and we\u2019ll get your whole classroom set up."
        )
      )
    ),
    _react2.default.createElement(
      "div",
      { className: textInput },
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        label: "SCAN OF YOUR FACULTY CARD",
        inputClassName: (0, _glamor.css)({
          textAlign: "left",
          color: _css.colors.lightGray,
          paddingTop: "0.7rem"
        }),
        type: "file",
        accept: "image/*,.pdf",
        icon: {
          color: _css.colors.lightGray,
          type: "folder",
          width: 24,
          height: 24,
          viewBox: "0 0 24 24"
        }
      }, props.photoProps, {
        placeholder: "Browse to select",
        loading: props.uploading,
        filename: props.fileName,
        onChange: props.onChangeFile
      }))
    ),
    _react2.default.createElement(
      "div",
      { className: (0, _glamor.css)(textInput, { margin: 0, display: "none" }) },
      _react2.default.createElement(
        "label",
        { className: dropDownLabel },
        "Education Program Type"
      ),
      _react2.default.createElement(_Select2.default, (0, _extends3.default)({
        className: selectField,
        options: programType,
        IndiePopup: true
      }, props.programTypeInputProps))
    ),
    _react2.default.createElement(
      "div",
      { className: (0, _glamor.css)(textInput, { margin: 0, display: "none" }) },
      _react2.default.createElement(
        "label",
        { className: dropDownLabel },
        "Duration of Class or course"
      ),
      _react2.default.createElement(_Select2.default, (0, _extends3.default)({
        className: selectField,
        options: duration,
        IndiePopup: true
      }, props.durationInputProps))
    ),
    _react2.default.createElement(
      "div",
      { className: textInput },
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        label: "Institution Name",
        placeholder: "Your school or institution name",
        type: "text",
        disabled: props.submitting,
        autoComplete: true,
        simpleError: true
      }, props.instituteNameInputProps))
    ),
    _react2.default.createElement(
      "div",
      { className: textInput },
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        label: "Url",
        placeholder: "Add a link to your institution",
        type: "text",
        disabled: props.submitting,
        autoComplete: true,
        simpleError: true
      }, props.urlInputProps))
    ),
    _react2.default.createElement(
      "div",
      { className: textInput },
      _react2.default.createElement(_TextArea2.default, (0, _extends3.default)({
        label: "Message",
        placeholder: "Tell us what you want to get out of the Megascans Educational Program.",
        type: "text",
        disabled: props.submitting,
        autoComplete: true
      }, props.MessageInputProps))
    ),
    props.shouldUpdateEula && _react2.default.createElement(
      "div",
      { className: checkboxContainer },
      _react2.default.createElement(_Checkbox2.default, {
        label: "I agree to the ",
        checked: props.eulaAccepted,
        onChange: props.onCheckboxChange
      }),
      " ",
      _react2.default.createElement(
        _reactRouter.Link,
        {
          className: anchor,
          to: "/terms",
          target: "_blank",
          rel: "noopener noreferrer"
        },
        "Content License Agreement."
      ),
      " "
    )
  );
}

var EducationSubscriptionPopup = function (_React$Component) {
  (0, _inherits3.default)(EducationSubscriptionPopup, _React$Component);

  function EducationSubscriptionPopup(props) {
    (0, _classCallCheck3.default)(this, EducationSubscriptionPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EducationSubscriptionPopup.__proto__ || (0, _getPrototypeOf2.default)(EducationSubscriptionPopup)).call(this, props));

    _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);

    _this.state = {
      eulaAccepted: false
    };
    return _this;
  }

  (0, _createClass3.default)(EducationSubscriptionPopup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({ eulaAccepted: !this.props.shouldUpdateEula });
    }
  }, {
    key: "handleCheckboxChange",
    value: function handleCheckboxChange(ev) {
      this.setState({
        eulaAccepted: ev.target.checked
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var eulaAccepted = this.state.eulaAccepted;


      return _react2.default.createElement(
        _Form2.default,
        {
          className: _IndieProgramPopup.popup,
          error: props.error,
          message: props.message,
          onSubmit: props.onSubmit,
          onChildRef: props.onChildRef
        },
        _react2.default.createElement(
          "div",
          { id: "signupScroll" },
          _react2.default.createElement(
            "div",
            { className: _IndieProgramPopup.header },
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement("img", { src: props.icon, alt: "", className: _IndieProgramPopup.icon }),
              _react2.default.createElement(
                "div",
                { className: _IndieProgramPopup.heading },
                _react2.default.createElement(
                  "h1",
                  { className: title },
                  props.title
                ),
                _react2.default.createElement(
                  "p",
                  { className: description },
                  props.description
                )
              )
            )
          ),
          _react2.default.createElement(
            "div",
            null,
            renderEducationSubscriptionForm((0, _extends3.default)({}, props, {
              eulaAccepted: eulaAccepted,
              onCheckboxChange: this.handleCheckboxChange
            })),
            _react2.default.createElement(
              "div",
              { className: foot },
              _react2.default.createElement(_Button2.default, {
                small: true,
                type: "submit",
                className: submitButton,
                mode: "secondary",
                disabled: !!props.message || props.uploading || !eulaAccepted,
                loading: props.submitting,
                label: props.label
              })
            )
          )
        )
      );
    }
  }]);
  return EducationSubscriptionPopup;
}(_react2.default.Component);

exports.default = EducationSubscriptionPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EducationSubscriptionPopup/EducationSubscriptionPopup.jsx
// module id = 2841
// module chunks = 0